export const BOOKS_OS_PLAY_URL =
    "https://play.google.com/store/apps/details?id=com.cuahangykhoa.cuahangykhoaapp";

export const BOOKS_OS_APP_STORE_URL =
    "https://apps.apple.com/vn/app/os-books/id6813926516?l=vi";


const getNavigatorValue = (
    userAgent,
    platform,
    maxTouchPoints
) => {

    const nav =
        typeof navigator !== "undefined"
            ? navigator
            : {};

    return {
        userAgent:
            typeof userAgent === "string"
                ? userAgent
                : nav.userAgent || "",

        platform:
            typeof platform === "string"
                ? platform
                : nav.platform || "",

        maxTouchPoints:
            typeof maxTouchPoints === "number"
                ? maxTouchPoints
                : Number(
                    nav.maxTouchPoints || 0
                )
    };
};


export const isAndroidDevice = (
    userAgent
) => {

    const device =
        getNavigatorValue(
            userAgent
        );

    return /Android/i.test(
        device.userAgent
    );
};


export const isIOSDevice = (
    userAgent,
    platform,
    maxTouchPoints
) => {

    const device =
        getNavigatorValue(
            userAgent,
            platform,
            maxTouchPoints
        );

    /*
     * iPhone / iPad / iPod:
     * UA thông thường.
     */
    if (
        /iPhone|iPad|iPod/i.test(
            device.userAgent
        )
    ) {
        return true;
    }

    /*
     * iPadOS mới có thể gửi UA giống macOS.
     * MacIntel + màn hình cảm ứng > 1 điểm
     * được coi là iPad.
     *
     * MacBook thông thường maxTouchPoints = 0
     * nên vẫn được đọc bằng web reader.
     */
    return (
        device.platform === "MacIntel" &&
        device.maxTouchPoints > 1
    );
};



export const isWindowsDevice = (
    userAgent,
    platform
) => {
    const device =
        getNavigatorValue(
            userAgent,
            platform
        );

    return (
        /Windows NT|Win32|Win64|Windows/i.test(
            device.userAgent
        ) ||
        /Win32|Win64|Windows/i.test(
            device.platform
        )
    );
};


export const isMobileBooksOSDevice = (
    userAgent,
    platform,
    maxTouchPoints
) => {

    return (
        isAndroidDevice(
            userAgent
        ) ||
        isIOSDevice(
            userAgent,
            platform,
            maxTouchPoints
        )
    );
};


export const getBooksOSStoreUrl = (
    userAgent,
    platform,
    maxTouchPoints
) => {

    if (
        isIOSDevice(
            userAgent,
            platform,
            maxTouchPoints
        )
    ) {
        return BOOKS_OS_APP_STORE_URL;
    }

    return BOOKS_OS_PLAY_URL;
};


export const openBooksOS = () => {

    if (
        typeof window === "undefined"
    ) {
        return;
    }

    window.location.href =
        getBooksOSStoreUrl();
};
